import Container = Phaser.GameObjects.Container;
import { Scene } from 'phaser';
import TileSprite = Phaser.GameObjects.TileSprite;
import Sprite = Phaser.GameObjects.Sprite;
import { ObjectPool } from './objectPool';
import GameObject = Phaser.GameObjects.GameObject;

export class GroundView extends Container {
    private sprites: Sprite[] = [];

    constructor(
        scene: Scene,
        private destX: number,
        private isWin: boolean,
    ) {
        super(scene);
        this.initSprites();

        this.scene.events.on('update', this.handleUpdate, this);
    }

    private initSprites() {
        let currentX = this.destX;
        let sprite: Sprite;
        const spike = 'spikes.png';
        const ground = 'landing_platform.png';
        let currentFrame = this.isWin ? ground : spike;
        while (currentX > -500) {
            sprite = this.scene.add.sprite(currentX, 0, 'game', currentFrame);
            sprite.setOrigin(0.5, currentFrame === spike ? 0.1 : 0);
            currentX -= 620;
            currentFrame = currentFrame === ground ? spike : ground;
            this.sprites.push(sprite);
            this.add(sprite);
        }
        sprite = this.sprites[0];
        currentX = this.destX;
        currentFrame = this.isWin ? spike : ground;
        currentX += currentFrame === spike ? 620 : 620;
        for (let i = 0; i < 5; i++) {
            sprite = this.scene.add.sprite(currentX, 0, 'game', currentFrame);
            sprite.setOrigin(0.5, currentFrame === spike ? 0.1 : 0);
            currentX += currentFrame === spike ? 620 : 620;
            currentFrame = currentFrame === ground ? spike : ground;
            this.sprites.push(sprite);
            this.add(sprite);
        }
    }

    public destroy(fromScene?: boolean) {
        this.scene.events.off('update', this.handleUpdate, this);
        super.destroy(fromScene);
    }

    private handleUpdate() {
        let sprite;
        let tx;
        for (let i = this.sprites.length - 1; i >= 0; i--) {
            sprite = this.sprites[i];
            tx = sprite.getWorldTransformMatrix().tx;
            sprite.setVisible(tx < 2220);
            if (tx < -300) {
                this.sprites.splice(i, 1);
            }
        }
    }
}
